<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Valentino's Love-Child</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><a id="page01"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>“I’m not talking about sex.”</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>He turned her to face him, and lowered his head so his lips hovered above hers. “Let’s not talk at all.”</span></p><p class="paraNoIndent1"><span>Then he kissed her. He would show her that they were too right together to dismiss their relationship because it wasn’t packaged in orange blossoms and meters of white tulle.</span></p><p class="paraNoIndent1"><span>She fought her own response. He could feel the tension in her, knew she wanted to resist, but as much as she might want to, she was as much a slave to their mutual attraction as he. Her body knew where it belonged. In his arms.</span></p><p class="paraNoIndent1"><span>But her brain was too active, and she tore her lips from his. “No, Tino.”</span></p><p class="paraNoIndent1"><span>“Do not say no. Say, rather, ‘Make love to me, Tino.’ This is what I wish to hear.”</span></p></div></a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// valentinoslovechild_fm01.vue?07a9d58a